import { useQuery } from '@tanstack/react-query';
import api from '@/lib/axios';

export interface PlanFeatures {
  medicos: number;
  asistentes: number;
  pacientes: number;
  consultorios: number;
  ikal: number;
  expedienteElectronico: boolean;
  cie: number;
  recetasDigitales: boolean;
  solicitudEstudios: boolean;
  consentimientos: boolean;
  almacenamiento: number;
  redMedica: boolean;
  finanzas: boolean;
  reportes: boolean;
  marketing: boolean;
  campañasMarketing: number;
  facturacion: boolean;
}

const FEATURES_DEFAULTS: PlanFeatures = {
  medicos: 1,
  asistentes: 1,
  pacientes: -1,
  consultorios: 1,
  ikal: 60,
  expedienteElectronico: true,
  cie: 11,
  recetasDigitales: true,
  solicitudEstudios: true,
  consentimientos: true,
  almacenamiento: 5,
  redMedica: true,
  finanzas: false,
  reportes: false,
  marketing: false,
  campañasMarketing: 0,
  facturacion: false,
};

function parseBoolean(v: any): boolean {
  if (v === true || v === 'true' || v === 1) return true;
  if (v === false || v === 'false' || v === 0) return false;
  return false;
}

function parseFuncionalidades(raw: Record<string, any> | null | undefined): PlanFeatures {
  if (!raw || Object.keys(raw).length === 0) return FEATURES_DEFAULTS;
  return {
    medicos:              Number(raw.medicos       ?? FEATURES_DEFAULTS.medicos),
    asistentes:           Number(raw.asistentes    ?? FEATURES_DEFAULTS.asistentes),
    pacientes:            Number(raw.pacientes      ?? FEATURES_DEFAULTS.pacientes),
    consultorios:         Number(raw.consultorios   ?? FEATURES_DEFAULTS.consultorios),
    ikal:                 Number(raw.ikal            ?? FEATURES_DEFAULTS.ikal),
    expedienteElectronico: parseBoolean(raw.expedienteElectronico ?? FEATURES_DEFAULTS.expedienteElectronico),
    cie:                  Number(raw.cie             ?? FEATURES_DEFAULTS.cie),
    recetasDigitales:     parseBoolean(raw.recetasDigitales    ?? FEATURES_DEFAULTS.recetasDigitales),
    solicitudEstudios:    parseBoolean(raw.solicitudEstudios   ?? FEATURES_DEFAULTS.solicitudEstudios),
    consentimientos:      parseBoolean(raw.consentimientos     ?? FEATURES_DEFAULTS.consentimientos),
    almacenamiento:       Number(raw.almacenamiento ?? FEATURES_DEFAULTS.almacenamiento),
    redMedica:            parseBoolean(raw.redMedica           ?? FEATURES_DEFAULTS.redMedica),
    finanzas:             parseBoolean(raw.finanzas            ?? FEATURES_DEFAULTS.finanzas),
    reportes:             parseBoolean(raw.reportes            ?? FEATURES_DEFAULTS.reportes),
    marketing:            parseBoolean(raw.marketing           ?? FEATURES_DEFAULTS.marketing),
    campañasMarketing:    Number(raw['campañasMarketing'] ?? raw.campanasMarketing ?? FEATURES_DEFAULTS.campañasMarketing),
    facturacion:          parseBoolean(raw.facturacion         ?? FEATURES_DEFAULTS.facturacion),
  };
}

export function usePlanFeatures() {
  const { data, isLoading } = useQuery({
    queryKey: ['suscripcion-verificar'],
    queryFn: () => api.get('/api/suscripcion/verificar').then(r => r.data),
    staleTime: 5 * 60 * 1000,
  });

  const raw: Record<string, any> | null = data?.neej?.plan?.funcionalidades ?? null;
  const features = parseFuncionalidades(raw);

  return { features, isLoading };
}
